export default __webpack_public_path__ + "static/media/bj.e423efb9.png";